import { Route } from "@angular/router";
import { StrapiResolver, StrapiRoute } from "@nx/strapi";
import { BadRequestComponent } from "../components/bad-request/bad-request.component";
import { ForbiddenComponent } from "../components/forbidden/forbidden.component";
import { InternalServerErrorComponent } from "../components/internal-server-error/internal-server-error.component";
import { NotFoundComponent } from "../components/not-found/not-found.component";
import { UnauthorizedComponent } from "../components/unauthorized/unauthorized.component";

export const badRequestState: StrapiRoute = {
  path: '400',
  data: {
    title: '400 | Learn My way',
    strapiUrl: "errors/400"
  },
  resolve: {
    cmsData: StrapiResolver
  },
  component: BadRequestComponent
}

export const unauthorizedState: StrapiRoute = {
  path: '401',
  data: {
    title: '401 | Learn My way',
    strapiUrl: "errors/401"
  },
  resolve: {
    cmsData: StrapiResolver
  },
  component: UnauthorizedComponent
}

export const forbiddenState: StrapiRoute = {
  path: '403',
  data: {
    title: '403 | Learn My way',
    strapiUrl: "errors/403"
  },
  resolve: {
    cmsData: StrapiResolver
  },
  component: ForbiddenComponent
}

export const notFoundState: StrapiRoute = {
  path: '404',
  data: {
    title: '404 | Learn My way',
    strapiUrl: "errors/404"
  },
  resolve: {
    cmsData: StrapiResolver
  },
  component: NotFoundComponent
}

export const internalServerErrorState: StrapiRoute = {
  path: '500',
  data: {
    title: '500 | Learn My way',
    strapiUrl: "errors/500"
  },
  resolve: {
    cmsData: StrapiResolver
  },
  component: InternalServerErrorComponent
}

export const redirectStateNotFound: Route = {
  path: '**',
  redirectTo: '404'
}

export const errorRootState: Route = {
  path: '',
  children: [
    badRequestState,
    unauthorizedState,
    forbiddenState,
    notFoundState,
    internalServerErrorState,
    redirectStateNotFound
  ]
}

export const AppStates = [errorRootState];